import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";

function svgProps(width, height, props) {
  return {
    width,
    height,
    // Magical 1.10.2 dropped viewBox on the wrapper, so CSS-sized icons clip.
    viewBox: width != null && height != null ? `0 0 ${width} ${height}` : undefined,
    ...props,
  };
}

export var createSvg = /*#__NO_SIDE_EFFECTS__*/ (symbol, width, height) => {
  let node = jsx("use", { href: symbol });

  return forwardRef((props, ref) => {
    return jsx("svg", { ref, ...svgProps(width, height, props), children: node });
  });
};

export var createSvgDEV = /*#__NO_SIDE_EFFECTS__*/ (xml, width, height) => {
  return forwardRef((props, ref) => {
    return jsx("svg", {
      ref,
      ...svgProps(width, height, props),
      dangerouslySetInnerHTML: { __html: xml },
    });
  });
};
